import { render } from "./PersonalData.vue?vue&type=template&id=cfcb4768"
const script = {}
script.render = render

export default script